import {Button, Space, Switch} from "@mantine/core";
import { SignIn as IconLogin, WarningCircle as IconAlertTriangle } from "@phosphor-icons/react";
import {useEffect, useState} from "react";
import Page from "../../components/Page/Page.tsx";
import api from "../../utils/api";
import FeatureList from "../meta/FeatureList.jsx";


const LoginPage = () => {
    const [env, setEnv] = useState(null);
    const [stayLogged, setStayLogged] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        api.get('/envConfig').then(res => {
            res.data.redirect_uri = window.location.origin+'/authorize';
            setEnv(res.data);
        }).catch(() => {
            setError(true);
        });
    }, []);

    return <Page className='md:mt-8 text-center'>
        <h1 className="mt-5 mb-3">Welcome to The Forge</h1>
        <div className='panel'>
            {env && env.maintenance > 0 && <div className="text-big text-orange-400 mb-2"><IconAlertTriangle size={16} style={{verticalAlign: 'middle'}} /> Site is in maintenance.</div>}
            {env !== null &&  <>
                <a href={`https://www.swcombine.com/ws/oauth2/auth/?response_type=code&client_id=${env.client_id}&redirect_uri=${encodeURIComponent(env.redirect_uri)}&scope=character_read&access_type=offline&renew_previously_granted=yes&state=login|${stayLogged ? 'y' : 'n'}|${window.location.pathname}`}
                ><Button leftSection={<IconLogin size={16} />}>Login using SW Combine</Button>
                </a><br /><br />
                <Switch checked={stayLogged} onChange={e => setStayLogged(e.currentTarget.checked)} label="Stay logged in" style={{display: 'inline-flex'}} />
            </>}
            {error ? <span className="text-red">Invalid system configuration, please contact a developer</span> : null}
        </div>
        <Space h="xl" />
        <FeatureList/>

    </Page>
}

export default LoginPage;
